<script>
    import news from "../../stores/news.js";
    import journal from "../../stores/journal.js";
    import Scroll from "../windows/Scroll.svelte";
    import t, { currentLocale } from "../../localization/t.js";

    export let window;

    $: hasNews = $news && $news.all && $news.all.length > 0;

    $: hasNews && journal.remember(`read about "${$news.all[0].title}" in local newspaper`);

    function dateFormatted(date) {
        return new Date(date).toLocaleDateString(currentLocale(), {
            month: "long",
            day: "numeric"
        });
    }
</script>

{#if hasNews}
    <Scroll isFocused={window.isFocused}>
        <ul>
            {#each $news.all as item}
                <li>
                    <a href={item.link} target="_blank" rel="noreferrer">
                        {item.title}
                    </a>
                    <br />
                    <time>{dateFormatted(item.publishedAt)}</time>
                </li>
            {/each}
        </ul>
    </Scroll>
{:else if !$news || $news.isLoading}
    <div>
        <p>{t("news.loading")}</p>
    </div>
{:else}
    <div>
        <p>{t("news.nothing_found")}</p>
    </div>
{/if}

<style>
    div {
        padding: var(--chrome-depth);
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: 1em;
        margin: 0;
        padding: 0;
        color: #666666;
        list-style-type: none;
    }

    a {
        color: #000000;
        font-size: 14px;
        font-family: serif;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }

    time {
        display: inline-block;
        margin-top: 2px;
    }

    li {
        border-top: #cccccc 2px ridge;
        padding-top: 1em;
    }

    li:first-child {
        border: none;
        padding: 0;
    }

    li:first-child a {
        display: inline-block;
        margin-bottom: 2px;
        font-size: 20px;
    }
</style>
